export const formatHour = (date: Date) => {
	let hours = date.getHours();
	let minutes = "" + date.getMinutes();

	minutes = +minutes < 10 ? "0" + minutes : minutes;
	return `${hours}:${minutes}`;
};

export const formatHourAMPMFromStringInput = (
	dateAsString: string,
	convertFromUtcToBrowserTime: boolean = false
) => {
	if (convertFromUtcToBrowserTime) {
		dateAsString =
			dateAsString[dateAsString.length - 1] === "Z"
				? dateAsString
				: `${dateAsString}Z`;
	}

	const date = new Date(dateAsString);

	return formatHour(date);
};

export const CalendarDefaultDaysInterval = 14;
export const CalendarMaxEvents = 20;

export const getAgendaStartDateString = () => {
	const startDate = new Date();
	const startMonth =
		startDate.getMonth() + 1 < 10
			? `0${startDate.getMonth() + 1}`
			: `${startDate.getMonth() + 1}`;
	return `${startDate.getFullYear()}-${startMonth}-${startDate.getDate()}T00:00:00.0000000`;
};

export const getAgendaEndDateString = () => {
	const startDate = new Date();
	const endDate = new Date(startDate);
	endDate.setDate(endDate.getDate() + CalendarDefaultDaysInterval);
	const endMonth =
		endDate.getMonth() + 1 < 10
			? `0${endDate.getMonth() + 1}`
			: `${endDate.getMonth() + 1}`;
	return `${endDate.getFullYear()}-${endMonth}-${endDate.getDate()}T23:59:59.0000000`;
};
